var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnNoPhotogrpher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#E5E5EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5001 18C16.5001 13.8579 19.8579 10.5 24.0001 10.5C28.1422 10.5 31.5001 13.8579 31.5001 18C31.5001 22.1421 28.1422 25.5 24.0001 25.5C19.8579 25.5 16.5001 22.1421 16.5001 18Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2521 41.5089C10.381 34.0259 16.4867 28 24.0001 28C31.5136 28 37.6194 34.0262 37.748 41.5094C37.7565 42.0057 37.4706 42.46 37.0195 42.667C33.0546 44.4863 28.6443 45.5 24.0006 45.5C19.3565 45.5 14.9458 44.4861 10.9806 42.6665C10.5295 42.4595 10.2436 42.0052 10.2521 41.5089Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnNoPhotogrpher);
export default __webpack_public_path__ + "static/media/icn_no_photogrpher.6cbd11e2b4d51a02de3d8c961035ec4d.svg";
export { ForwardRef as ReactComponent };